module.exports = __webpack_public_path__ + "static/Положение_об_официальном_сайте.doc";